module.exports = __webpack_public_path__ + "assets/img/cwxg.06f9c74c.jpg";